import { render, staticRenderFns } from "./MeetingSimpleCardDesktop.vue?vue&type=template&id=51beade2&scoped=true"
import script from "./MeetingSimpleCardDesktop.vue?vue&type=script&lang=js"
export * from "./MeetingSimpleCardDesktop.vue?vue&type=script&lang=js"
import style0 from "./MeetingSimpleCardDesktop.vue?vue&type=style&index=0&id=51beade2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51beade2",
  null
  
)

export default component.exports